import React from 'react';
import { withTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './ReactDateRangePicker.scss';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import i18next from 'i18next';
import { faCalendarAlt, faChevronDown } from '@fortawesome/pro-light-svg-icons';



class ReactDateRangePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ranges: this.parseRanges(this.props.ranges),
            currentLang: i18next.language,
        };
    }

    componentDidUpdate = () => {
        if (i18next.language !== this.state.currentLang) {
            this.setState({
                currentLang: i18next.language,
                ranges: this.parseRanges(this.props.ranges)
            });
        };
    };

    parseRanges = (ranges) => {
        const { disableTranslations, t } = this.props;

        if (disableTranslations) {
            return ranges;
        }

        let newRanges = {};

        for (let key in ranges) {
            newRanges[t('periods.' + key)] = ranges[key];
        }

        return newRanges;
    }

    render() {
        const { startDate, endDate, onApply = () => { }, autoApply = true, periodLabel, customContainerStyle, customClass, onHide } = this.props;
        let { ranges } = this.state;

        let customClassAUX = typeof customClass !== undefined ? customClass : '';
        let containerStylesAUX = typeof customContainerStyle !== undefined ? customContainerStyle : '';

        let locale = {
            firstDay: 1
        };

        return (
            <React.Fragment>
                <DateRangePicker
                    initialSettings={{
                        startDate: startDate,
                        endDate: endDate,
                        ranges: ranges,
                        onApply: onApply,
                        className: 'drp',
                        autoApply: autoApply,
                        locale: locale,
                        alwaysShowCalendars: false,
                        containerClass: clsx('drp-container-styles', containerStylesAUX),
                    }}
                    key={this.state.currentLang}
                    onApply={onApply}
                    onHide={onHide}

                >
                    <Button className={clsx('drp-button', customClassAUX)} color="inherit">
                        <div className="drp-value-container">
                            <FontAwesomeIcon className="drp-calendar-icon" icon={faCalendarAlt} />
                            {periodLabel}
                        </div>
                        <div className={clsx('drp-container-styles-container', "pull-right")}>
                            <FontAwesomeIcon className="drp-chevron-icon" icon={faChevronDown} />
                        </div>
                    </Button>
                </DateRangePicker>
            </React.Fragment>
        );
    }
}

export default withTranslation('common')(ReactDateRangePicker);